"use client";

import { ProposalInterviewTypeText, ProposalStatusText } from "@entities/proposal/constants";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { formatDateTime } from "@shared/utils";
import { Badge, Button } from "@ubud-ui/react-ui-kit";
import Link from "next/link";
import { Proposal } from "../../types";
import { Vacancy, VacancyableType } from "@entities/vacancy";

export function ProposalStatusCard({ vacancy, proposal }: { vacancy: Vacancy; proposal: Proposal }) {
  const client = useClientConfig();

  if (!proposal) {
    return <></>;
  }

  return (
    <div className="border border-gray-200 rounded-xl p-4 flex flex-col space-y-5 overflow-hidden bg-primary-50">
      <div className="flex flex-col space-y-3">
        <div>
          <div className="flex items-center gap-2 justify-between">
            <div className="font-bold text-gray-700 flex-1">Status Lamaran</div>
            <Button variant="link" className="p-0 m-0 w-auto h-auto text-sm gap-1 font-bold" asChild>
              <Link
                href={
                  client?.config.siapkerjaAppUrl +
                  "/karirhub/vacancy/" +
                  vacancy.id +
                  "?type=" +
                  (vacancy.vacancyableType === VacancyableType.MICRO_VACANCY ? "micro_vacancy" : "domestic_vacancy")
                }
              >
                Lihat Detil
              </Link>
            </Button>
          </div>
          <div className="mt-2">
            <Badge shape="pill" variant="outline" className="bg-white">
              {ProposalStatusText[proposal.status]}
            </Badge>
          </div>
        </div>
        {proposal.activeInterview && (
          <div className="mt-4 pt-4 border-t border-gray-200 space-y-3">
            <div className="flex justify-between gap-1 flex-col">
              <div className="text-sm font-medium text-gray-500">Jadwal Wawancara</div>
              <div className="flex-1 font-semibold text-sm">{formatDateTime(proposal.activeInterview.interviewSchedule)} WIB</div>
            </div>
            <div className="flex justify-between gap-1 flex-col">
              <div className="text-sm font-medium text-gray-500">Tipe Wawancara</div>
              <div className="flex-1 font-semibold text-sm">{ProposalInterviewTypeText[proposal.activeInterview.type]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
